module.exports = __webpack_public_path__ + "static/media/pin-map.3e1ba46e.svg";